<template>
  <div class="flex flex-col items-center justify-center p-8" :class="containerClass">
    <svg
      class="animate-spin"
      :class="spinnerClass"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        :stroke-width="strokeWidth"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <p v-if="message" class="mt-4 text-center" :class="textClass">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    message: {
      type: String,
      default: 'Loading...'
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value)
    },
    color: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'gray', 'white', 'black'].includes(value)
    },
    containerClass: {
      type: String,
      default: ''
    },
    textClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    spinnerClass() {
      const sizeClasses = {
        sm: 'h-6 w-6',
        md: 'h-10 w-10',
        lg: 'h-14 w-14',
        xl: 'h-20 w-20'
      }
      
      const colorClasses = {
        primary: 'text-blue-500',
        secondary: 'text-purple-500',
        gray: 'text-gray-500',
        white: 'text-white',
        black: 'text-black',
        blue : 'text-blue-500',
        green: 'text-teal-600',
      }
      
      return `${sizeClasses[this.size]} ${colorClasses[this.color]}`
    },
    strokeWidth() {
      return this.size === 'xl' ? '4' : '3'
    }
  }
}
</script>